import React from "react";
var __jsx = React.createElement;
/**
 * Default block for Switch component
 */
export var Default = function Default(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};